export default __webpack_public_path__ + "media/images/flags/id-c53d788f98f4a4d53891fe619b0a95a2.png";